/* eslint-disable no-underscore-dangle */
import React from 'react';
import { SbEditableContent } from 'storyblok-react';
import { Props } from '../../types';
import { OldLayout } from './old-layout';
import { ModernLayout } from './modern-layout';

type PageProps = Props<{ body: SbEditableContent[] }>;

enum PressLayout {
  MODERN = 'modern',
  OLD = 'old',
}

export const PagePressNews = ({ blok, getComponent }: PageProps): JSX.Element => {
  const layouts = {
    [PressLayout.MODERN]: ModernLayout,
    [PressLayout.OLD]: OldLayout,
  };

  const Layout = layouts[blok.layout || PressLayout.OLD];

  return <Layout blok={blok} getComponent={getComponent} />;
};
